import api from "./client";

export async function listUsers(params = {}) {
  const res = await api.get("/users", { params });
  return res.data.data.items;
}

export async function getUser(id) {
  const res = await api.get(`/users/${id}`);
  return res.data.data;
}

export async function createUser(payload) {
  const res = await api.post("/users", payload);
  return res.data.data;
}

export async function updateUser(id, payload) {
  const res = await api.put(`/users/${id}`, payload);
  return res.data.data;
}

export async function deleteUser(id) {
  const res = await api.delete(`/users/${id}`);
  return res.data.data;
}

export async function listIntakeReceivers() {
  const res = await api.get("/users/intake-receivers");
  return res.data.data.items;
}

export async function listFormingOperators() {
  const res = await api.get("/users/forming-operators");
  return res.data.data.items;
}
